<template>
	<div>
<!--		<breadcrumb />-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-optionItem">
				<div class="h-optionItemin">
					<ul>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon1">
									<div class="h-tableCell" @click="addweek" style="cursor: pointer;">
										<p>制定计划</p>
										<span>新建计划</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon2">
									<div class="h-tableCell" @click="demandPage" style="cursor: pointer;">
										<p>需求分析</p>
										<span>新建需求</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon3">
									<div class="h-tableCell" @click="managePage" style="cursor: pointer;">
										<p>项目管理</p>
										<span>转化项目</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon4">
									<div class="h-tableCell" @click="orderMore" style="cursor: pointer;">
										<p>在线下单</p>
										<span>在线下单</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon5">
									<div class="h-tableCell" @click="orderMore" style="cursor: pointer;">
										<p>订单跟踪</p>
										<span>订单跟踪</span>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon6">
									<div class="h-tableCell" @click="contractPage" style="cursor: pointer;">
										<p>合同管理</p>
										<span>转化合同</span>
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<!-- <div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div style="display:flex;justify-content:space-between;align-items:center;padding:20px 0;">
							<div style="color:#0072f6;font-size:16px;">模块展示</div>
							<div style="display:flex;align-items:center;"></div>
						</div>
					</div>
				</div>
			</div> -->
			<div class="h-row">
				<div class="h-rowIn" style="width: 50%;">
					<div class="h-rowBox" style="height: 8.2rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell" style="height:100%;display:flex;justify-content:space-between;align-items:center;">
									<h1>销量总量</h1>
									<div class="h-calendarSelect" style="margin-left: 0;">
										<div class="h-csBox">
											<el-select v-model="yearValue2" placeholder="请选择" @change="getSaleRank">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue2" placeholder="请选择"
												@change="getSaleRank">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<div class="selecBox">
										<div class="button" :class="{'active':indx==index}" v-for="(item,index) in buttonlist" :key="index" @click="tab(index)">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank0" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 90%;">
							</div>
							<div v-if="areaFlag">
								<div class="agentBox" style="height: 6rem;overflow-y: auto;">
									<div class="agent" v-for="(item,index) in regionSale" :key="index">
										<div class="agentTop">
											<div class="circle" style="{'border-color':'#005cfd'}"></div>
											<div class="titles">{{item.regionName}}</div>
										</div>
										<div class="agentBottom">
											<div class="zhaobox" :style="{'width':item.target/20+'%'}">
												<div class="zhao" :style="{'background':'#005cfd','width':item.actual/20+'%'}">
													<div class="imgs">已实现{{item.actual}}万</div>
												</div>
											</div>
											<div class="nums" v-if="item.target">{{item.target}}万</div>
										</div>
									</div>
								</div>
								<div class="agentBox" style="padding-top: 0;">
									<div class="lines" style="margin-top:50px;"></div>
									<div class="lineBox">
										<div class="test">销售目标</div>
										<div class="linelist" v-for="(item1,index1) in shixianlistagent" :key="index1">{{item1}}</div>
									</div>
								</div>
							</div>
							<div v-if="agentFlag">
								<div class="agentBox" style="height: 6rem;overflow-y: auto;">
									<div class="agent" v-for="(item,index) in agentSale" :key="index">
										<div class="agentTop">
											<div class="circle" style="{'border-color':'#005cfd'}"></div>
											<div class="titles">{{item.username}}</div>
										</div>
										<div class="agentBottom">
											<div class="zhaobox" :style="{'width':item.monthlyGoals/5+'%'}">
												<div class="zhao" :style="{'background':'#005cfd','width':item.actual*100/item.monthlyGoals+'%'}">
													<div class="imgs">已实现{{item.actual}}万</div>
												</div>
											</div>
											<div class="nums">{{item.monthlyGoals}}万</div>
										</div>
									</div>
								</div>
								<div v-if="agentFlag" class="agentBox" style="padding-top: 0;">
									<div class="lines" style="margin-top:50px;"></div>
									<div class="lineBox">
										<div class="test">销售目标</div>
										<div class="linelist" v-for="(item2,index2) in shixianlist" :key="index2">{{item2}}</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="h-rowIn" style="width: 50%;">
					<div class="h-rowBox" style="height: 4.1rem">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1 class="">绩效排名</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank1_1&&blank1_2" style="display:flex;justify-content: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 62%;">
							</div>
							<div v-else style="display:flex;">

								<div class="h-pieChart" v-show="!blank1_1||!blank1_2" id="h_lineChart1" style="width: 70%; height: 2.5rem;flex-shrink:0"></div>
								<div style="display:flex;flex-direction: column;width: 30%;" v-show="!blank1_1||!blank1_2">
									<div class="selecBox" style="margin-top:20px;">
										<div class="button" :class="{'active':paidex==index}" v-for="(item,index) in paiminglist" :key="index" @click="tab2(index)">{{item}}</div>
									</div>
									<div v-if="paidex==0" class="paimingBox">
										<div class="title">当天绩效排名<span style="margin-left:10px;font-weight:bold">{{jxDayRank}}</span></div>
										<div class="borderBox">
											<div class="borders" :style="{width:jxDayWidth}"></div>
										</div>
									</div>
									<div v-if="paidex==1" class="paimingBox">
										<div class="title">当月绩效排名<span style="margin-left:10px;font-weight:bold">{{jxMonthRank}}</span></div>
										<div class="borderBox">
											<div class="borders" :style="{width:jxMonthWidth}"></div>
										</div>
									</div>
								</div>
							</div>
							<div class="textBox" v-show="!blank1_1||!blank1_2">
								<span>当天排名<span style="color:#8b8b8b;margin-left:5%;">{{jxDayRank}}</span></span>
								<span>当月排名<span style="color:#8b8b8b;margin-left:5%;">{{jxMonthRank}}</span></span>
								<!-- <span style="color:#bae5c0;margin-left:10%;">+16.1%</span> -->
							</div>
						</div>
					</div>
					<div class="h-rowBox" style="margin-top: 0.24rem;height:3.86rem">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>跑动排名</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div style="display:flex;">
								<div class="blankimg" v-if="blank2" style="text-align: center;">
									<img src="../../../assets/images/mylittle.png"  style="width: 57%;">
								</div>
								<div class="h-pieChart" id="h_lineChart" v-show="!blank2" style="width: 85%; height: 2.5rem;"></div>
								<div style="display:flex;flex-direction: column;width: 15%;" v-show="!blank2">
									<div style="margin-top:30px;color:#525962;font-size:22px;">{{care}}</div>
									<div style="margin-top:10px;font-size:18px;color:#d1d8db">总排名</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 61.5%;">
					<div class="h-rowBox" style="height: 7.4rem;">
						<div class="h-rowTitle">
							<div class="h-disTable" style="display: flex;align-items: center;">
								<div class="h-tableCell" style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
									<h1>我的日程</h1>
									<div class="h-calendarSelect" style="margin-left: -0.25rem;">
										<div class="h-csBox">
											<el-select v-model="yearValue" placeholder="请选择" @change="handleYearClick">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue" placeholder="请选择"
												@change="handleMonthClick">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<div class="h-calenderSign" style="margin-left: -0.2rem;">
										<span><i class="h-redBg"></i>已过期</span>
										<span><i class="h-blueBg"></i>当前</span>
										<span><i class="h-greenBg"></i>提醒</span>
									</div>
									<el-button class="h-btn h-formBtn h-bgblueQ2" @click="addweek">创建周计划</el-button>
								</div>
							</div>
						</div>
						<div class="h-rowCon" style="position:relative">
							<el-calendar v-model="calenderValue"  style="overflow:hidden;">
								<template slot="dateCell" slot-scope="{date, data}">
									<div class="h-day" @click="handleDateClick(date)">
										<div style="height:0.9rem;;overflow:hidden;">
											<span class="h-dayNum">
												{{data.day.split('-')[2].replace(/^0+/,'')}}
												<div v-for="(item,index) in calenderData" :key="index">
													<i class='h-daySign h-blueBg' v-if="item.planTimeEnd.split(' ')[0]>$util.riQi3(tdate)&&data.day==item.planTimeEnd.split(' ')[0]" ></i>
													<i class='h-daySign h-redBg' v-if="$util.riQi3(tdate)>item.planTimeEnd.split(' ')[0]&&data.day==item.planTimeEnd.split(' ')[0]" ></i>
													<i class='h-daySign h-greenBg' v-if="$util.riQi3(tdate)==item.planTimeEnd.split(' ')[0]&&data.day==item.planTimeEnd.split(' ')[0]" ></i>
												</div>
											</span>
											<div style="padding-top:0.35rem;height:0.79rem;;overflow:hidden;">
												<div v-for="(item,index) in calenderData" :key="index" @click="selecttime(data.day)" class="calenderdata">
													<div class="h-dataInfo"
														v-if="
																data.day.split('-')[2].replace(/^0+/,'')==item.planTimeEnd.split(' ')[0].split('-')[2].replace(/^0+/,'')
																&& data.day.split('-')[1].replace(/^0+/,'')==item.planTimeEnd.split(' ')[0].split('-')[1].replace(/^0+/,'')">
														<p>{{item.planTimeStart.split(' ')[1].substr(0,5)}}~{{item.planTimeEnd.split(' ')[1].substr(0,5)}}
														</p>
														<p>{{item.euName}} {{item.planRemark}}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</el-calendar>
							<div class="planBoxzhezhao" v-if="planBoxlist">
								<div class="planBoxs">
									<div class="planBoxtop">{{detailDayString}}</div>
									<div class="planBoxcenter">
										<div class="planBoxcenterlist" v-for="(item,index) in planlists" :key="index">
											<div class="divs">
												<div v-if="item.active!=0" class="nullwan">未完成</div>
												<div v-if="item.active==0" class="nullwan" style="border: solid 1px #4caf50;background:0;color: #65ba69;">已完成</div>
											</div>
											<div class="divs">
												<div class="centertext" :title="item.euName?item.euName:''">{{item.euName?item.euName:''}}</div>
											</div>
											<div class="divs">
												<div class="baifantext" :title="item.contact">{{item.contact}}</div>
											</div>
											<div class="divs">
												<!-- <div class="timetext" :title="item.planTimeStart.substr(0,16)+'--'+item.planTimeEnd.substr(0,16)" v-if="item.planTimeEnd.split(' ')[0]!=item.planTimeStart.split(' ')[0]"> {{item.planTimeStart.substr(0,16)}}--{{item.planTimeEnd.substr(0,16)}}</div>
												<div class="timetext" :title="item.planTimeEnd.split(' ')[1].substr(0,5)+'--'+item.planTimeEnd.split(' ')[1].substr(0,5)" v-if="item.planTimeEnd.split(' ')[0]==item.planTimeStart.split(' ')[0]"> {{item.planTimeEnd.split(' ')[1].substr(0,5)}}--{{item.planTimeEnd.split(' ')[1].substr(0,5)}}</div> -->
											</div>
											<div class="divs">
												<div v-if="item.active==1" class="editortext" @click="editorplan(item.id)">修改计划</div>
												<div v-if="item.active==2&&item.planStatus!=4&&item.planStatus!=5" class="editortext" @click="tibaobut(item.id)" style="background:#ee9433;">提报原因</div>
											</div>
											<div class="divs">
												<div class="chakan" @click="checkDetail(item.id)">查看</div>
											</div>
										</div>
									</div>
									<div class="planBoxbottom">
										<div class="backtext" @click="planBoxlist=false">返回</div>
										<div class="h-pagination fenyes">
											<paginationmincopy :page="q1" @query="selecttimeQ(detailDayString)" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-----------------------代办start-->
				<tasklist divheight="7.4rem" :pagesize="10"/>
				<!-----end-->
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 50%;">
					<div class="h-rowBox" style="height:8.95rem">
						<div class="h-rowTitle">
							<div class="h-disTable" style="display: flex;align-items: center;">
								<div class="h-tableCell" style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
									<h1>订单跟踪</h1>
									<el-button class="h-btn h-formBtn h-bgblueQ2" @click="orderMore">查看更多</el-button>
								</div>
							</div>
						</div>
						<div class="blankimg" v-if="blank3" style="margin-top: 50px;">
							<img src="../../../assets/images/mylittle.png"  style="width: 100%;">
						</div>
						<div class="h-rowCon">
							<div class="h-formRead">
								<div class="h-formReadList" v-for="(item,index) in dingd" :key="index">
									<div class="h-formWrap h-wrap50">
										<label>订单号：</label>
										<span>{{item.sapCode}}</span>
									</div>
									<div class="h-formWrap h-wrap50">
										<label>产品型号：</label>
										<span>{{item.materialName}}</span>
									</div>
									<div class="h-formWrap h-wrap50">
										<label>产品编码：</label>
										<span>{{item.materialCode}}</span>
									</div>
									<div class="h-formWrap h-wrap50">
										<label>订单日期：</label>
										<span>{{item.cdate}}</span>
									</div>
									<div class="h-formWrap h-wrap50">
										<label>客户名称：</label>
										<span>{{item.soldToName}}</span>
									</div>
									<div class="h-formWrap h-wrap50">
										<label>订单总额：</label>
										<span>{{item.orderPrice}}元</span>
									</div>
									<div class="h-trackResult">
										<span class="h-cg h-trInfo" v-if="item.active==0">草稿</span>
										<span class="h-rComplete h-trInfo" v-if="item.active==1">进行中</span>
										<span class="h-rComplete h-trInfo" v-if="item.active==2">已完成</span>
										<div class="h-ystep">
											<el-steps :space="200" :active="item.active" finish-status="success">
											  <el-step title=""></el-step>
											  <el-step title=""></el-step>
											  <el-step title=""></el-step>
											</el-steps>
										</div>
										<div class="h-fr h-formIcon">
											<a class="h-formIcon2" @click="dingDetail(item)"></a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="h-rowIn" style="width: 50%;">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>资源需求排名</h1>
									<div class="h-calendarSelect">
										<div class="h-csBox">
											<el-select v-model="yearValue3" placeholder="请选择" @change="getResourceRank">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue3" placeholder="请选择"
												@change="getResourceRank">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon" style="height: 3.6rem;">
							<div class="blankimg" v-if="blank4_1&&blank4_2" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 66%;">
							</div>
							<div style="display:flex;" class="h-mapChart" v-show="!blank4_1||!blank4_2">
								<div class="h-pieChart" id="h_lineChart2" style="width: 70%; height: 3.2rem;flex-shrink:0"></div>
								<div style="display:flex;flex-direction: column;width: 30%;">
									<div class="selecBox" style="margin-top:20px;">
										<div class="button" :class="{'active':paidex1==index}" v-for="(item,index) in paiminglist1" :key="index" @click="tab3(index)">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="h-rowBox" style="margin-top: 0.24rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>信贷使用</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon" style="height: 3.67rem;">
							<div class="blankimg" v-if="blank5" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 65%;">
							</div>
							<div class="h-mapChart" id="h_radar" v-show="!blank5"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell">
									<h1>项目漏斗</h1>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="h-funnelChart">
								<div class="h-funnelChartIn">
									<div class="h-funnelItem">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R0"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0*6.46rem);">
											<span>共{{total0}}条，已转化{{finish0}}条，未转化{{incomplete0}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion0}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 80%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R1"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.1*6.46rem);">
											<span>共{{total1}}条，已转化{{finish1}}条，未转化{{incomplete1}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion1}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 65%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R2"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.174*6.46rem);">
											<span>共{{total2}}条，已转化{{finish2}}条，未转化{{incomplete2}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion2}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 52%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R3"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.24*6.46rem);">
											<span>共{{total3}}条，已转化{{finish3}}条，未转化{{incomplete3}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion3}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 40%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R4"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.3*6.46rem);">
											<span>共{{total4}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion4}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
									<div class="h-funnelItem" style="width: 25%;">
										<span class="h-funnelTxt">
											<dictname category="xinxi_jiedian" v="R5"/>
										</span>
										<div class="h-funnelR" style="width:calc(4rem + 0.374*6.46rem);">
											<span>共{{total5}}条</span>
										</div>
										<div class="h-funnelL">
											<span class="h-funnelLTxt">转化率{{proportion5}}%</span>
											<i></i>
											<span class="h-funnelLine"></span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :close-on-click-modal="false" title="查看详情" :visible.sync="dialogFormVisible3" class="h-dialog">
			<div class="h-runningDetail" style="border-top:0;padding:0.32rem;padding-left: 0.5rem;">
				<div class="h-rdTitle">
					<h1>{{qdetail.euName}}</h1>
					<label v-if="qdetail.executionId">已拜访</label>
					<label v-if="!qdetail.executionId">未拜访</label>
				</div>
				<div class="h-rdForm" >
					<div class="h-rdFormWrap" style="width:100%;height:0.5rem">
						<p class="h-grayFont" style="display:inline-block;margin-right:0.3rem">拜访时间</p>
						<div v-if="qdetail.ex" style="display:inline-block"></div>
						<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]!=qdetail.planTimeStart.split(' ')[0]" style="display:inline-block">{{qdetail.planTimeStart.substr(0,16)}} -- {{qdetail.planTimeEnd.substr(0,16)}}</p>
						<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]==qdetail.planTimeStart.split(' ')[0]" style="display:inline-block">{{qdetail.planTimeEnd.split(' ')[1].substr(0,5)}}--{{qdetail.planTimeEnd.split(' ')[1].substr(0,5)}}</p>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">负责人</p>
						<p>{{qdetail.contact}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont">部门/科室</p>
						<p>{{qdetail.contactDept}}</p>
					</div>
					<div class="h-rdFormWrap" style="padding-left: 1.2rem;box-sizing:border-box;text-align:center">
						<p class="h-grayFont">拜访对象</p>
						<div v-if="qdetail.euType">
							<p><dictname category="userCareType" :v="qdetail.euType"/></p>
						</div>
					</div>
					<div class="h-rdFormWrap" style="text-align:left;">
						<p class="h-grayFont">联系方式</p>
						<p>{{qdetail.contactPhone}}</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap">
						<p class="h-grayFont" style="color:#fff">&nbsp;</p>
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈内容</p>
						<el-input type="textarea" maxlength="200" :value="qdetail.planRemark?qdetail.planRemark:(qdetail.userCareExecution?qdetail.userCareExecution.planRemark:'')" readonly></el-input>
						<!-- <p>{{qdetail.planRemark?qdetail.planRemark:''}}</p> -->
					</div>
					<div class="h-rdFormWrap" style="width:100%;text-align:left;">
						<p class="h-grayFont">洽谈结果</p>
						<p >{{qdetail.userCareExecution?qdetail.userCareExecution.result:''}}</p>
					</div>

				</div>
			</div>
		  <div slot="footer" class="dialog-footer">
			  <el-button class="h-btn h-bBtn" :class="[qdetail.userCareExecution&&qdetail.userCareExecution.transform==0?'h-bgwhite':'h-bgblueQ2']" @click="dialogFormVisible3 = false">返回</el-button>
			  <el-button v-if="qdetail.userCareExecution&&qdetail.userCareExecution.transform==0" class="h-btn h-formBtn h-bgblueQ2" type="primary" @click="zhuanhuaxuqiu">一键转化需求</el-button>
		  </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="过期拜访计划原因提报" :visible.sync="dialogFormVisible1" v-if="dialogFormVisible1" class="h-dialog">
		  <div class="h-formLine">
			  <el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
				 <el-form-item label="拜访客户" class="h-elformWrap-1">{{formLabelAlign3.euName}}
					<span class="h-readOnlyTxt"></span>
				  </el-form-item>
				 <el-form-item label="客户类型" class="h-elformWrap-1">
					<span class="h-readOnlyTxt"><dictname category="userCareType" :v="formLabelAlign3.euType"/></span>
				  </el-form-item>
				  <el-form-item label="拜访时间" class="h-elformWrap-1">
					<span class="h-fl">
					  <span class="h-readOnlyTxt">{{formLabelAlign3.planTimeStart}}</span>
					</span>
					<el-col class="line h-txtCenter" :span="2">至</el-col>
					<span class="h-fl">
					  <span class="h-readOnlyTxt">{{formLabelAlign3.planTimeEnd}}</span>
					</span>
				  </el-form-item>
				  <!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.areaCode | dictname('YLRegion')}}
				  </el-form-item>
				  <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.channelCode | dictname('sales_region')}}
				  </el-form-item> -->
			  </el-form>
			  <div class="h-formPiece yxgundong">
				  <el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="部门/科室" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">{{formLabelAlign3.contactDept}}</span>
					  </el-form-item>
					  <el-form-item label="关键人" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">{{formLabelAlign3.contact}}</span>
					  </el-form-item>
					  <el-form-item label="联系方式" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">{{formLabelAlign3.contactPhone}}</span>
					  </el-form-item>
					  <el-form-item label="洽谈内容" prop="formCon10" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">{{formLabelAlign3.planRemark}}</span>
					  </el-form-item>
				  </el-form>
			  </div>
			  <!-- <div class="h-formRow">
				<el-form ::model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="位置信息" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">
							<span>{{formLabelAlign3.province}}</span>
							<span>{{formLabelAlign3.city}}</span>
							<span>{{formLabelAlign3.county}}</span>
						</span>
						<p class="h-readOnlyTxt">
							{{formLabelAlign3.address}}
						</p>
					  </el-form-item>
				  </el-form>
			  </div> -->
			  <div class="h-formReason">
				 <el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="过期原因" class="h-elformWrap-1" prop="explain">
						<el-input type="textarea" v-model="formLabelAlign3.remark" style="height: 23px;"></el-input>
					  </el-form-item>
				  </el-form>
			  </div>
		  </div>
		  <div slot="footer" class="dialog-footer">
			<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible1 = false">取 消</el-button>
			<el-button class="h-btn h-formBtn h-bgblue2" @click="submitReasonOrChange(1)">提交保存</el-button>
		  </div>
		</el-dialog>
		<el-dialog :close-on-click-modal="false" title="计划修改" :visible.sync="dialogFormVisible2" class="h-dialog">
			<div style="margin-top:10px;font-size:16px;color:#f23522;text-align:center;">温馨提示：修改后本次交互计划将转为未达成状态，请慎重选择。</div>
		  <div class="h-formLine">
			  <el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
				 <el-form-item label="客户类型" class="h-elformWrap-1" prop="euType">
					<el-select v-model="formLabelAlign3.euType" placeholder="请选择" @change="customerType(formLabelAlign3)">
						<el-option  v-for="(item) in options2"
									:key="item.code"
									:label="item.name"
									:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="拜访客户" class="h-elformWrap-1" prop="euCode">
					<template>
						<el-select v-if="formLabelAlign3.euType==1" v-model="formLabelAlign3.euCode"  @change="selectGet(formLabelAlign3)"  placeholder="请选择">
							<el-option  v-for="(item) in optionsAgent"
										:key="item.userCode"
										:label="item.userName"
										:value="item.userCode">
							</el-option>
						</el-select>
						<el-select v-else-if="formLabelAlign3.euType==2" v-model="formLabelAlign3.euCode"  @change="selectGet(formLabelAlign3)"  placeholder="请选择">
							<el-option  v-for="(item) in optionsCustomer"
										:key="item.userCode"
										:label="item.userName"
										:value="item.userCode">
							</el-option>
						</el-select>
						<el-select v-else-if="!formLabelAlign3.euType" v-model="formLabelAlign3.euCode"  @change="selectGet(formLabelAlign3)"  placeholder="请选择">
							<el-option  v-for="(item) in []"
										:key="item.userCode"
										:label="item.userName"
										:value="item.userCode">
							</el-option>
						</el-select>
					</template>
				  </el-form-item>
				  <el-form-item label="拜访时间" class="h-elformWrap-1" >
					<span class="h-fl">
					  <el-date-picker :clearable="false" v-model="formLabelAlign3.planTimeStart" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
					</span>
					<el-col class="line h-txtCenter" :span="2">至</el-col>
					<span class="h-fl">
					  <el-date-picker :clearable="false" v-model="formLabelAlign3.planTimeEnd" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
					</span>
				  </el-form-item>
				  <!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==1">
						<brselect category="YLRegion" :v="formLabelAlign3.areaCode" v-model="formLabelAlign3.areaCode"
                            placeholder="--请选择--"></brselect>
				  </el-form-item>  -->
				  <!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.areaCode | dictname('YLRegion')}}
				  </el-form-item>
				  <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
						{{formLabelAlign3.channelCode | dictname('sales_region')}}
				  </el-form-item> -->
				  <!-- <el-form-item label="区域" class="h-elformWrap-2" v-if="formLabelAlign3.euType!=1">
						<el-input v-model="formLabelAlign3.areaName" placeholder="根据客户自动带出" readonly></el-input>
				  </el-form-item>
				  <el-form-item label="用户渠道" class="h-elformWrap-2" v-if="formLabelAlign3.euType==2">
							<el-input v-model="formLabelAlign3.channelCode" placeholder="根据客户自动带出" readonly></el-input>
				  </el-form-item> -->
			  </el-form>
			  <div class="h-formPiece">
				  <el-form :model="formLabelAlign3" label-position="right" :rules="rules2" ref="formLabelAlign3" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="部门/科室" class="h-elformWrap-1">
						<el-input placeholder="根据客户自动带出" v-model="formLabelAlign3.contactDept"></el-input>
					  </el-form-item>
					  <el-form-item label="关键人" class="h-elformWrap-1">
						<el-input placeholder="根据客户自动带出" v-model="formLabelAlign3.contact"></el-input>

					  </el-form-item>
					  <el-form-item label="联系方式" class="h-elformWrap-1" prop="contactPhone">
						<el-input placeholder="根据客户自动带出" v-model.number="formLabelAlign3.contactPhone"></el-input>

					  </el-form-item>
					  <el-form-item label="洽谈内容" prop="planRemark" class="h-elformWrap-1">
						<el-input placeholder="请输入" v-model="formLabelAlign3.planRemark"></el-input>
					  </el-form-item>
				  </el-form>
			  </div>
		  </div>
		  <div slot="footer" class="dialog-footer">
			<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible2 = false">取 消</el-button>
			<el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitReasonOrChange(2)">确认修改</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
    import tasklist from '@/components/task/mytask.vue';
	import ss from "../../../api/SystemService";
	import big from 'big.js'

    export default {
			components:{
					tasklist
			},
        	data() {
            return {
				agentSale:[],
				areaFlag:false,
				agentFlag:true,
				blank0:false,
				blank1_1:false,
				blank1_2:false,
				blank2:false,
				blank3:false,
				blank4_1:false,
				blank4_2:false,
				blank5:false,
				msgAgent:false,
				total0: 0,
				total1: 0,
				total2: 0,
				total3: 0,
				total4: 0,
				total5: 0,
				finish0: 0,
				finish1: 0,
				finish2: 0,
				finish3: 0,
				incomplete0: 0,
				incomplete1: 0,
				incomplete2: 0,
				incomplete3: 0,
				proportion0: 0,
				proportion1: 0,
				proportion2: 0,
				proportion3: 0,
				proportion4: 0,
				proportion5: 0,
				jxDayData:"",
				jxDayValue:"",
				jxDayRank:"无",
				jxDayWidth:"0%",
				jxMonthData:"",
				jxMonthValue:"",
				jxMonthRank:"无",
				jxMonthWidth:"0%",
				dingd:"",
				deptTimeData:"",
				deptTimeValue:"",
				deptNumData:"",
				deptNumValue:"",
				regionSale:[],
				year:"",
				month:"",
				care:"",
				shixianlist:["0","100万","200万","300万","400万","500万"],
				shixianlistagent:["0","400万","800万","1200万","1600万","2000万"],
				indx:0,
				buttonlist:['经销商','区域'],
				paiminglist:['当天排名','当月排名'],
				paiminglist1:['解决数量','响应时间(h)'],
				paidex:0,
				paidex1:0,
				options: [{
				value: '选项1',
				label: '已完成'
				}, {
				value: '选项2',
				label: '未完成'
				}, {
				value: '选项3',
				label: '未开始'
				}],
				value: '',
				calenderValue:new Date(),
			        yearOptions:[{
			        	value:'2017',
			        	label:'2017'
			        },{
			        	value:'2018',
			        	label:'2018'
			        },{
			        	value:'2019',
			        	label:'2019'
			        },{
			        	value:'2020',
			        	label:'2020'
			        }],
			        monthOptions:[{
			        	value:'1',
			        	label:'1月'
			        },{
			        	value:'2',
			        	label:'2月'
			        },{
			        	value:'3',
			        	label:'3月'
			        },{
			        	value:'4',
			        	label:'4月'
			        },{
			        	value:'5',
			        	label:'5月'
			        },{
			        	value:'6',
			        	label:'6月'
			        },{
			        	value:'7',
			        	label:'7月'
			        },{
			        	value:'8',
			        	label:'8月'
			        },{
			        	value:'9',
			        	label:'9月'
			        },{
			        	value:'10',
			        	label:'10月'
			        },{
			        	value:'11',
			        	label:'11月'
			        },{
			        	value:'12',
			        	label:'12月'
					}],
					tdate: new Date(),
			        yearValue:new Date().getFullYear()+"年",
					monthValue:new Date().getMonth()+1+"月",
					yearValue2:new Date().getFullYear()+"年",
					monthValue2:new Date().getMonth()+1+"月",
					yearValue3:new Date().getFullYear()+"年",
					monthValue3:new Date().getMonth()+1+"月",
					//日历
					calenderData: [],
					planList:[{}],
					detailDayString: "",
					planBoxlist:false,
					//提报原因
					dialogFormVisible1:false,
					//修改计划
					dialogFormVisible2:false,
					//详情查看
					dialogFormVisible3:false,
					formLabelAlign3:{},
					qdetail:{},
					rules2: {
					// formCon1: [
					// 	{ required: true, message: '', trigger: 'blur' },
					// ],
					euType: [
						{ required: true, message: '请选择客户类型', trigger: 'blur' },
					],
					euCode: [
						{ required: true, message: '请选择拜访客户', trigger: 'blur' },
					],
					planTimeStart: [
						{ required: true, message: '请选择拜访时间', trigger: 'blur' },
					],
					planTimeEnd: [
						{ required: true, message: '请选择拜访时间', trigger: 'blur' },
					],
					remark: [
						{ required: true, message: '请输入过期原因', trigger: 'blur' },
					],
					// formCon9:[
					// 	{ required: true, message: '联系方式不能为空' ,trigger: 'blur' },
      				// 	{ type: 'number', message: '联系方式必须为数字值', trigger: 'blur' }
					// ]

				},
				options2:[],
				//表单
				q: {
					pageSize: 8,
					pageNo: 1,
					total: 0,
				},
				//表单上面日历点击后页面
				q1: {
					pageSize: 4,
					pageNo: 1,
					total: 0,
				},
				planlists:[
					{
						active:0,
						title:'青岛大学附属医院血液柜拜访',
						baifang:'常规拜访',
						time:'11:30~12:30',
					}
				],
            }
        	},
        methods: {
			queryAgenda() {
				ss.UserCare.allplan({ year: this.yearValue.split("年")[0], month: this.monthValue.split("月")[0] }).then(rd => {
					this.calenderData = rd.plans;
					console.log(this.calenderData, "日程");
				})
			},
			customerType(v){
				console.log(v,"客户类型变更");
				v.euCode='';
				v.euName='';
				v.channelCode='';
				v.areaCode='';
			},
			//下拉框选中事件
			selectGet(v){//这个vId也就是value值
				let obj = {};
				if(v.euType==1){
					//客户经销商
					obj = this.optionsAgent.find((item)=>{//这里的userList就是上面遍历的数据源
						return item.userCode === v.euCode;//筛选出匹配数据
					});
				}else{
					obj = this.optionsCustomer.find((item)=>{//这里的userList就是上面遍历的数据源
						return item.userCode === v.euCode;//筛选出匹配数据
					});
					v.areaName=this.$getDictName('YLRegion', obj.areaCode);
				}
					console.log(obj,"修改后用户信息");
					v.euName=obj.userName;//我这边的name就是对应label的
					v.channelCode=obj.channelCode;
					v.areaCode=obj.areaCode;
					v.contactDept=obj.department;
					v.contactPhone=obj.telephone;
					v.contact=obj.contactuserName;

			},
			submitReasonOrChange(v){
				//过期未执行提报原因
				console.log(this.formLabelAlign3,"过期未执行提报原因");
				let msg="确认修改计划？";
				var subflag=true;
				if(v==1){
					msg="确认提报原因？";
					if(!this.formLabelAlign3.remark){
						this.$msg.msge("请填写提报原因");
						this.$refs['formLabelAlign3'].validate((valid) => {
							return valid;
						})
						subflag=false;
					}
					this.formLabelAlign3.planStatus=4;//提交
				}else{
					//修改计划
					this.formLabelAlign3.planStatus=2;//提交
				}
				if(subflag){
					this.$msg.confirm(msg,()=>{
						ss.UserCare.updateById(this.formLabelAlign3).then(rd => {
							console.log(rd,"右边图表下");
							this.$msg.msgs("提交成功");
							this.dialogFormVisible1=false;
							this.dialogFormVisible2=false;
						})
					})
				}
			},
			checkDetail(item) {
				//查看详情
				console.log(item);
				this.dialogFormVisible3 = true
				ss.UserCare.planDetail({id:item}).then(rd => {
					console.log(rd,"左边日历查看详情");
					this.qdetail=rd.plan;
				})
			},
			//日历点击这个时间，日历点击那天的时间
			selecttime(times){
				this.q1.pageNo = 1;
				this.selecttimeQ(times);
			},
			//翻页
			selecttimeQ(times){
				// console.log(this.$util.riQi3(this.tdate))
				this.detailDayString=times;
				//交互计划详情\
				this.q1.planTimeEndEnd=times
				this.q1.planTimeStartBegin=times
				ss.UserCare.selectPage(this.q1).then(rd => {
					console.log(rd,"左面表格");
					this.q1.total = rd.total;
					this.planlists = rd.records;
					if(this.planlists&&this.planlists.length>0){
						this.planlists.forEach((item,index)=>{
							if(item.planTimeEnd>this.$util.riQi3(this.tdate)&&!item.executionId&&(item.planStatus==2||item.planStatus==6)){
								//今天之前没有执行的计划
								item.active=1;
							}
							if(item.planTimeEnd<this.$util.riQi3(this.tdate)&&!item.executionId){
								//今天之后没有执行的计划
								item.active=2;
							}
							if(item.executionId){
								item.active=0;
							}
						})
					}
				})
				this.planBoxlist = true;
			},
			tibaobut(item){
				this.dialogFormVisible1 = true;
				ss.UserCare.planDetail({id:item}).then(rd => {
					console.log(rd,"提报原因右边图表下");
					this.formLabelAlign3=rd.plan;
				})
			},
			editorplan(item){
				this.dialogFormVisible2 = true;
				ss.UserCare.planDetail({id:item}).then(rd => {
					console.log(rd,"修改计划右边图表下");
					this.formLabelAlign3=rd.plan;
					console.log(this.formLabelAlign3);
					console.log(this.optionsAgent);
				})
			},
			demandPage(){
				this.$router.push({path:"/xuqiu/Lmanagement"});
			},
			managePage(){
				this.$router.push({path:"/xiangmu/pm"});
			},
			newProjectPage(){
				this.$router.push({path:"/xiangmu/newProject", query:{type:"new"}});
			},
			contractPage(){
				this.$router.push({path:"/contract-list"});
			},
			dingDetail(row){
				if(row.orderCategory == '1'){
				    this.$router.push({path: "/dingdmain/orderNxshenpi", query: {id:row.bid, instid:row.binstid, taskstatus:'1', f:'1'}})
				}else {
				    this.$router.push({path: "/dingdmain/orderWxshenpi", query: {id:row.bid,instid:row.binstid, taskstatus:'1', f:'1'}})
				}
			},
			orderMore(){
				this.$router.push({path:"/dingd/dingdmainlist"});
			},
			handleSizeChange(v){
				console.log(v)
			},
			handleCurrentChange(v){
				console.log(v)
			},
			tab(index){
				this.indx = index;
				if(index == 0){
					this.areaFlag = false;
					this.agentFlag = true;
					this.getAgentMonthlySale();
				}else{
					this.areaFlag = true;
					this.agentFlag = false;
					this.getSaleDataByRegion();
				}
			},
			getSaleRank(){
				if(this.indx == 0){
					this.getAgentMonthlySale();
				}else{
					this.getSaleDataByRegion();
				}
			},
			tab2(index){
				this.paidex = index;
				this.lineChart1(index);
			},
			tab3(index){
				this.paidex1 = index;
				if(index==0){
					this.getOverRanking();
					this.map();
				}else{
					this.getTimeRanking();
					this.map2();
				}
			},
			//我的日程年的切换
			handleYearClick() {
				this.calenderValue = (this.yearValue + "-" + this.monthValue).split("月")[0]
				this.queryAgenda();
			},
			//我的日程月的切换
			handleMonthClick() {
				this.calenderValue = this.yearValue.split("年")[0] + "-" + this.monthValue
				console.log(this.calenderValue, "-------------日历值");
				this.queryAgenda();
			},
			handleDateClick(a) {
				this.yearValue = a.getFullYear() + "年";
				this.monthValue = a.getMonth() + 1 + "月"
			},
			addweek(){
				//创建周计划，查询当前用户下周计划状态
				var planstatus=0;
				ss.UserCare.weekPlanStatus().then(rd => {
					console.log(rd,"点击新建周计划判断");
					if(rd.obj&&rd.obj.length>0){
						planstatus=rd.obj[0].planStatus;
						if(planstatus==1){
							this.$msg.msge("周计划已提交，请等待审核");
						}else if(planstatus==2){
							this.$msg.msge("周计划已生成，请勿重复操作");
						}else{
							this.$router.push("/weekplan");
						}
					}else{
						this.$router.push("/weekplan");
					}
				})
			},
			pieChart(){

			},
			lineChart(){
				let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
				let option = {
					grid:{
						top:"20px",
						left:"0px",
						right:"15px",
						bottom:"30px"
					},
					tooltip: {
						trigger: 'axis',
						axisPointer:{
							show: true,
							lineStyle: {
								color:'#61a0f7'
							}
					   }
					},
					legend: {
						show:false
					},
					calculable: true,
					xAxis: [{
						type: 'category',
						data: [],
						axisLine:{
							show:false,
							onZero:true
						},
						splitLine: {
							show:false
						},
						axisTick:{
							show:false
						},
						axisLabel: {
							show: true,
							color:'#b9b9b9',
							fontFamily:'Microsoft YaHei',
							fontSize:13
						}
					}],
					yAxis: [{
						type: 'value',
						axisLine: {
							show:false
						},
						splitLine: {
							show:false
						},
						axisTick:{
							show:false
						},
						axisLabel: {
							show:false
						}
					}],
					series: [{
							name: '跑动排名',
							type: 'line',
							symbol: 'circle',
							symbolSize: 0,
							showSymbol: false,
							areaStyle:{
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0, color: 'rgba(145,188,250,1)' // 0% 处的颜色
									},{
										offset: 0.5, color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
									}, {
										offset: 1, color: 'rgba(145,188,250,0)' // 100% 处的颜色
									}],
									globalCoord: false // 缺省为 false
								},
							},
							smooth:true,
							data: [],
							lineStyle:{
								color:'#61a0f7'
							},
							itemStyle: {
								normal: {
									color: '#ffffff',
									borderColor: '#61a0f7',
									borderWidth: 2
								}
							}
						}
					]
				};
				lineChart.setOption(option);
			},
			lineChart1(index){
				var jxDayRank = this.jxDayRank;
				var jxMonthRank = this.jxMonthRank;
				let lineChart1 = this.$echarts.init(document.getElementById('h_lineChart1'));
				var dataAxis = [];
				var data = [];
				var dataShadow = [];
				let option = {
					grid:{
						top:"20px",
						left:"10px",
						right:"10px",
						bottom:"40px"
					},
					xAxis: {
						show : false,
						data: dataAxis,
						axisLabel: {
							inside: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						z: 10
					},
					yAxis: {
						show : false,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						}
					},
					dataZoom: [
						{
							type: 'inside'
						}
					],
					series: [
						{ // For shadow
							type: 'bar',
							barWidth:"5%",
							barGap:"10%",
							itemStyle: {
								normal: {color: 'rgba(0,0,0,0.05)',
								barBorderRadius: 5,
								}
							},
							barGap:'-100%',
							barCategoryGap:'40%',
							data: dataShadow,
							animation: false
						},
						{
							type: 'bar',
							itemStyle: {
								normal: {
									// color: '#61a8fd',
									color: function(params){
										if((index==0 && params.dataIndex+1==jxDayRank)||(index==1 && params.dataIndex+1==jxMonthRank)){
											return '#F4A82D';
										}else{
											return '#61a8fd';
										}
									},
									barBorderRadius: 5,
								}
							},
							data: data
						}
					]
				};
				lineChart1.setOption(option);
				if(index==0){
					lineChart1.setOption({
						xAxis:{
							data:this.jxDayData
						},
						series:[{
							name:'shadow',
							data:this.jxDayValue
						},
						{
							name:'bar',
							data:this.jxDayValue
						}]
					})
				}else{
					lineChart1.setOption({
						xAxis:{
							data:this.jxMonthData
						},
						series:[{
							name:'shadow',
							data:this.jxMonthValue
						},
						{
							name:'bar',
							data:this.jxMonthValue
						}]
					})
				}
			},
			radar(){
				let radarChart = this.$echarts.init(document.getElementById('h_radar'));
				let option= {
					// grid:{
					// 	x: 40,
					// 	x2: 50,
					// 	y2: 100
					// },
					tooltip: {
						trigger: 'item'
					},
					legend: {
						// show:false
						data:[],
						bottom:0
					},
					color:["#409EFF","#F1622E"],
					radar: [
						{
							nameGap : 5,
							indicator: [],
							center: ['50%','50%'],
							radius: 100,
							name: {
								textStyle: {
									color:'#717d8c'
								}
							},
							splitArea: {
								show: true
							},
							splitLine:{
								lineStyle:{
									color:'#d9dde3'
								}
							},
							axisLine:{
								lineStyle:{
									color:'#d9dde3'
								}
							},
							axisTick:{
								show:true
							},

						},
					],
					series: [
						{
							type: 'radar',
							 tooltip: {
								trigger: 'item'
							},
							symbolSize:1,
							// itemStyle: {
							// 	color: '#004eff',
							// },
							// areaStyle: {
							// 	normal: {
							// 		opacity: 0.49
							// 	}
							// },
							// lineStyle:{
							// 	color:"#54a1ec",
							// 	width:0
							// },
							// label:{
							// 	show:false,
							// 	color:'#717d8c',
							// 	fontSize:14,
							// 	position:'inside'
							// },
							data: []
						},
					]
				}
				radarChart.setOption(option);
			},
			map(){
				let myChart = this.$echarts.init(document.getElementById('h_lineChart2'));
				var dataAxis = [];
				var data = [];
				var dataShadow = [];
				let option = {
					grid:{
						top:"20px",
						left:"25px",
						right:"10px",
						bottom:"40px"
					},
					xAxis: {
						show : true,
						data: dataAxis,
						axisLabel: {
							inside: false,
							textStyle: {
								color: '#999'
							},
							interval:0,
							rotate:30
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						z: 10
					},
					yAxis: {
						show : false,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						}
					},
					dataZoom: [
						{
							type: 'inside'
						}
					],
					series: [
						{ // For shadow
							type: 'bar',
							name: 'shadow',
							barWidth:"5%",
							barGap:"10%",
							itemStyle: {
								normal: {
									color: 'rgba(0,0,0,0.05)',
									barBorderRadius: 5,
								}
							},
							barGap:'-100%',
							barCategoryGap:'40%',
							data: dataShadow,
							animation: false
						},
						{
							type: 'bar',
							name: 'bar',
							itemStyle: {
								normal: {
									color: '#61a8fd',
									barBorderRadius: 5,
									label:{
										show:true,
										position:'top',
										color:'#999',
									}
								},
								emphasis: {
									color: '#61a8fd'
								}
							},
							data: data
						}
					]
				};
				myChart.setOption(option);
				myChart.setOption({
					xAxis:{
						data:this.deptNumData
					},
					series:[{
						name:'shadow',
						data:this.deptNumValue
					},
					{
						name:'bar',
						data:this.deptNumValue
					}]
				});
			},
			map2(){
				let myChart = this.$echarts.init(document.getElementById('h_lineChart2'));
				var dataAxis = [];
				var data = [];
				var dataShadow = [];
				let option = {
					grid:{
						top:"20px",
						left:"10px",
						right:"10px",
						bottom:"40px"
					},
					xAxis: {
						show : true,
						data: dataAxis,
						axisLabel: {
							inside: false,
							textStyle: {
								color: '#999'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						z: 10
					},
					yAxis: {
						show : false,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							textStyle: {
								color: '#999'
							}
						}
					},
					dataZoom: [
						{
							type: 'inside'
						}
					],
					series: [
						{ // For shadow
							type: 'bar',
							barWidth:"5%",
							barGap:"10%",
							itemStyle: {
								normal: {color: 'rgba(0,0,0,0.05)',
								barBorderRadius: 5,
								}
							},
							barGap:'-100%',
							barCategoryGap:'40%',
							data: dataShadow,
							animation: false
						},
						{
							type: 'bar',
							itemStyle: {
								normal: {
									color: '#61a8fd',
									barBorderRadius: 5,
									label:{
										show:true,
										position:'top',
										color:'#999',
									}
								},
								emphasis: {
									color: '#61a8fd'
								}
							},
							data: data
						}
					]
				};
				myChart.setOption(option);
				myChart.setOption({
					xAxis:{
						data:this.deptTimeData
					},
					series:[{
						name:'shadow',
						data:this.deptTimeValue
					},
					{
						name:'bar',
						data:this.deptTimeValue
					}]
				})
			},
			getSaleDataByRegion(){
				ss.firstPageService.getSaleDataByRegion({month:this.getMonthStr(this.yearValue2,this.monthValue2,'')}).then(rd=>{
					this.regionSale = rd.obj;
					if(rd.obj.length == 0) {
						this.blank0 = true;
					}else{
						this.blank0 = false;
					}
				});
			},
			getMonthStr(yearValue, monthValue, separator){
				var year = yearValue.split('年')[0];
				var month = monthValue.split('月')[0];
				month = month.length==1?'0'+month:month;
				return year + separator + month;
			},
			getOverRanking(){
				ss.firstPageService.getOverRanking({month:this.getMonthStr(this.yearValue3,this.monthValue3,'-')}).then(rd=>{
					var deptData = [];
					var deptValue = [];
					if(rd!=null && rd.length>0){
						this.blank4_1=false;
						for(var i=0;i<rd.length;i++){
							var cl = rd[i];
							deptData.push(cl.depName);
							deptValue.push(cl.ranking);
						}
						this.deptNumData = deptData;
						this.deptNumValue = deptValue;
						let lineChart = this.$echarts.init(document.getElementById('h_lineChart2'));
						lineChart.setOption({
							xAxis:{
								data:deptData
							},
							series:[{
								name:'shadow',
								data:deptValue
							},
							{
								name:'bar',
								data:deptValue
							}]
						})
					}else{
						this.blank4_1=true;
					}
				});
			},
			getTimeRanking(){
				ss.firstPageService.getTimeRanking({month:this.getMonthStr(this.yearValue3,this.monthValue3,'-')}).then(rd=>{
					this.blank4_2=false;
					var deptData = [];
					var deptValue = [];
					if(rd!=null && rd.length>0){
						for(var i=0;i<rd.length;i++){
							var cl = rd[i];
							deptData.push(cl.depName);
							deptValue.push(cl.date);
						}
						this.deptTimeData = deptData;
						this.deptTimeValue = deptValue;
					}else{
						this.blank4_2=true;
					}
				});
			},
			getResourceRank(){
				if(this.paidex1==0){
					this.getOverRanking();
					this.getTimeRanking();
					this.map();
				}else{
					this.getOverRanking();
					this.getTimeRanking();
					this.map2();
				}
			},
			showLoud(){
				ss.firstPageService.showLoud().then(rd=>{
					this.total0 = parseInt(rd.R0?rd.R0:0) + parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total1 = parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total2 = parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total3 = parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.total4 = parseInt(rd.R4?rd.R4:0);
					this.total5 = parseInt(rd.R5?rd.R5:0);
					this.finish0 = parseInt(rd.R1?rd.R1:0) + parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish1 = parseInt(rd.R2?rd.R2:0) + parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish2 = parseInt(rd.R3?rd.R3:0) + parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.finish3 = parseInt(rd.R4?rd.R4:0) + parseInt(rd.R5?rd.R5:0);
					this.incomplete0 = this.total0 - this.finish0;
					this.incomplete1 = this.total1 - this.finish1;
					this.incomplete2 = this.total2 - this.finish2;
					this.incomplete3 = this.total3 - this.finish3;
					this.proportion0 = this.total0 == 0? 0:(new big(this.finish0).div(this.total0)).times(100);
					this.proportion1 = this.total1 == 0? 0:(new big(this.finish1).div(this.total1)).times(100);
					this.proportion2 = this.total2 == 0? 0:(new big(this.finish2).div(this.total2)).times(100);
					this.proportion3 = this.total3 == 0? 0:(new big(this.finish3).div(this.total3)).times(100);
					this.proportion4 = this.total2 == 0? 0:(new big(this.total4).div(this.total2)).times(100);
					this.proportion5 = this.total3 == 0? 0:(new big(this.total5).div(this.total3)).times(100);
				})
			},
			getAgentMonthlySale(){
				ss.firstPageService.getAgentMonthlySale({month:this.getMonthStr(this.yearValue2,this.monthValue2,'-')}).then(rd=>{
					this.agentSale = rd;
					if (rd.length==0){
						this.blank0 = true;
					}else{
						this.blank0 = false;
					}
				})
			},
        //it服务台通知 每人只通知一次
        showITService(){
            // 提示通知
            let val = localStorage.getItem("showITService1");
            val = JSON.parse(val);
            console.log("123123",val);
            //如果缓存有效并且未过期
            if(val==null||val=='true'){
                //这里再对数据库进行校验 防止缓存被清除
                this.$alert("   为提升系统运维服务，量化系统运维质量，OMS运维已启用IT服务台，大家有问题请通过IT服务台提交，运维人员优先解决IT服务台提交的问题，谢谢！</br>IT服务器台路径：系统右下角，点击“IT服务台”图标", 'OMS系统运维启用IT服务台通知', {
                    confirmButtonText: '确定',
                    dangerouslyUseHTMLString: true,
                    type:'warning',
                });
                //将缓存置为无效
                val = 'false';
                console.log("JSON.stringify(val)",JSON.stringify(val))
                localStorage.setItem("showITService1", JSON.stringify(val));
            }
        },
            //系统维护通知
            showMaintain(){
                // 提示通知
                let val = localStorage.getItem("showNotifyMain");
                val = JSON.parse(val);
                console.log(val, "缓存main");
                console.log(val, "缓存login");

				//如果是经销商 或者是区域经理省区经理,以及平台人员
				if(this._user.usertype == '1' || this.msgAgent){
					//如果缓存有效并且未过期
					if(val.showNotify||val.showNotify=='true'){

						const aLiUrl = require("../../../assets/images/agengtmsg.png")

						if (Date.now()/1000/60/60 - val.time/1000/60/60 < val.expire) {
							this.$alert("<strong><img src="+ aLiUrl + ">", '系统通知', {
								confirmButtonText: '确定',
								dangerouslyUseHTMLString: true,
                customClass: 'big-image-alert', // 添加自定义类
							});

							//将缓存置为无效
							val.showNotify = false;
							//localStorage 设置的值不能为对象,转为json字符串
							localStorage.setItem("showNotifyMain", JSON.stringify(val));
						}
					}
				}
            },
		},
		created(){
			this.queryAgenda();
			this.options2 = this.$store.getters.dicts["userCareType"];

        //it服务台通知 没人只通知一次
        this.showITService();
        // 提示通知
        this.showMaintain();


		/*	val = JSON.parse(val);
			console.log(val, "缓存main");
			//如果缓存有效并且未过期
			if(val.showNotify||val.showNotify=='true'){
				if (Date.now()/1000/60/60 - val.time/1000/60/60 < val.expire) {
					 this.$alert("各位用户，运维邮箱已调整成yuanhangyl@yuanh.com.cn,有问题请发送邮件", '系统通知', {
					 	confirmButtonText: '确定',
					 	type:'warning',
					 });
			/!*		this.$alert("系统将于2021年4月28号19点至21点进行升级，请勿进行操作，避免数据丢失！届时将影响用户体验，敬请谅解!", '系统通知', {
						confirmButtonText: '确定',
						type:'warning',
					});
					*!/
					//将缓存置为无效
					val.showNotify = false;
					//localStorage 设置的值不能为对象,转为json字符串
					localStorage.setItem("showNotifyMain", JSON.stringify(val));
				}
			}*/

		},
		mounted(){
			this.map();
			this.pieChart();
			this.lineChart();
			this.lineChart1();
			this.radar();
			//产品销量
			// this.getSaleDataByRegion();
			this.year = new Date().getFullYear();
			this.month = new Date().getMonth()+1;
			this.msgAgent = this.$store.getters.hasRole('swyl_daqujl,swyl_quyujl,SHICHANG_PINGTAI,swyl_caiwujl');
			//经销商销量
			this.getAgentMonthlySale();
			//跑动排行
			ss.firstPageService.getUserCareRanking().then(rd=>{
				var careData = [];
				var careValue = [];
				if(rd.careList!=null && rd.careList.length > 0){
					for(var i=0;i<rd.careList.length;i++){
						var cl = rd.careList[i];
						careData.push(cl.orderDate);
						careValue.push(cl.orderNo);
					}
					this.care = rd.care;
					let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
					lineChart.setOption({
						xAxis:[{
							data:careData
						}],
						series:[{
							data:careValue
						}]
					})
				}else{
					this.blank2 = true;
				}
			});
			//资源需求排名  解决数量
			this.getOverRanking();
			//资源需求排名  响应时间
			this.getTimeRanking();
			//项目漏斗
			this.showLoud();
			//绩效排行,当天
			ss.firstPageService.getJiXiaoRanking({type:'day'}).then(rd=>{
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if(rd.list!=null && rd.list.length > 0){
					for(var i=0;i<rd.list.length&&i<10;i++){
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if(cuser==cl.cuname){
							this.jxDayRank = parseInt(cl.id);
							this.jxDayWidth = (rd.list.length-cl.id+1)*100/rd.list.length + '%';
						}
					}
					this.jxDayData = jxData;
					this.jxDayValue = jxValue;
					this.lineChart1(0);
				} else {
					this.blank1_1 = true;
				}
			});
			//绩效排行,当月
			ss.firstPageService.getJiXiaoRanking({type:'month'}).then(rd=>{
				var cuser = rd.cuser;
				var jxData = [];
				var jxValue = [];
				if(rd.list!=null && rd.list.length > 0){
					for(var i=0;i<rd.list.length&&i<10;i++){
						var cl = rd.list[i];
						jxData.push(cl.cuname);
						jxValue.push(cl.proTotalAmount);
						if(cuser==cl.cuname){
							this.jxMonthRank = parseInt(cl.id);
							this.jxMonthWidth = (rd.list.length-cl.id+1)*100/rd.list.length + '%';
						}
					}
					this.jxMonthData = jxData;
					this.jxMonthValue = jxValue;
				} else {
					this.blank1_2 = true;
				}
			});
			//订单跟踪
			ss.OrderMainService.selectDingdanPage({pageNo:1,pageSize:3}).then(rd=>{
				this.dingd = rd.records;
				if(this.dingd==null||this.dingd.length==0){
					this.blank3 = true;
				}
				for(var i=0;i<this.dingd.length;i++){
					var dd = this.dingd[i];
					if(dd.orderStatus==10){
						dd.active = 0;
					}else if(dd.orderStatus>=90){
						dd.active=2;
					}else{
						dd.active=1;
					}
				}
			});
			//信贷使用
			ss.firstPageService.getCreditStatus().then(rd=>{
				if(rd!=null && rd.length > 0){
					var username = [];
					var max = [];
					var used = [];
					var overdue = [];
					for(var i=0;i<rd.length;i++){
						var cl = rd[i];
						max.push({text:cl.userName,max:cl.maxQuota});
						used.push(cl.maxQuota-cl.leftQuota);
						overdue.push(cl.overdueAmount);
					}
					let radarChart = this.$echarts.init(document.getElementById('h_radar'));
					radarChart.setOption({
						legend:{
							data:["已使用信贷额","逾期信贷额"],
							width: 100,
							right: 10,
							top: '40%'
						},
						radar:[{
							indicator:max
						}],
						series:[{
							data:[
								{
									name:"已使用信贷额",
									value:used
								},
								{
									name:"逾期信贷额",
									value:overdue
								}
							]
						}]
					})
				}else{
					this.blank5 = true;
				}
			});

		},
    }
</script>
<style scoped>
.h-funnelChart .h-funnelItem .h-funnelR {
	height: 0.64rem;
	line-height: 0.62rem;
	position: absolute;
	left: calc(100% + 0.6rem);
	top: -0.64rem;
	width: 5rem;
	color: #3b77fd;
	font-size: 0.18rem;
	text-align: left;
	padding-left: 0.56rem;
	background-image: url(../../../assets/images/trapezoid1.png);
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.selecBox{
	display: flex;
}
.selecBox .button{
	width: 85px;
	height: 32px;
	color: #767676;
	text-align: center;
	line-height: 28px;
	border:1px solid #dddfe4;
	background: #fff;
	cursor: pointer;
	font-size: 0.16rem;
}
.selecBox .button.active{
	background: #2686e7;
	color: #fff;
	border-color: #2686e7;
}
.planBoxzhezhao{
	width: 100%;
	height: 6.3rem;
	background: rgba(0, 0, 0, 0.3);
	position: absolute;
	top: 10px;
	left: 0;
	box-sizing: border-box;
}
.planBoxs{
	width: 90%;
	height: 90%;
	background: #fff;
	border: 1px solid #c4c4c4;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	padding: 40px 40px 20px 40px;
	box-sizing: border-box;
}
.planBoxs .planBoxtop{
	font-size: 18px;
	color: #282828;
}
.planBoxs .planBoxcenter{
	margin-top: 10px;
}
.planBoxs .planBoxcenter .planBoxcenterlist{
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	border-bottom: 1px solid #eee;
}
.planBoxs .planBoxcenter .planBoxcenterlist .divs{
	width: 16.666%;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
	text-align: center;
}
.planBoxs .planBoxcenter .planBoxcenterlist .yellowtext{
	width: 61px;
	height: 29px;
	background-color: #fbdfc8;
	border-radius: 15px;
	font-size: 14px;
	color: #ee9433;
	text-align: center;
	line-height: 29px;
}
.planBoxs .planBoxcenter .planBoxcenterlist .centertext{
	font-size: 14px;
	color: #323232;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.planBoxs .planBoxcenter .planBoxcenterlist .baifantext{
	font-size: 14px;
	color: #a7a7a7;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.planBoxs .planBoxcenter .planBoxcenterlist .timetext{
	font-size: 14px;
	color: #a7a7a7;
	overflow: hidden;
	text-overflow:ellipsis;
	white-space: nowrap;
}
.planBoxs .planBoxcenter .planBoxcenterlist .nullwan{
	width: 74px;
	height: 29px;
	border-radius: 15px;
	border: solid 1px #ee9433;
	font-size: 14px;
	color: #ee9433;
	text-align: center;
	line-height: 29px;
}
.planBoxs .planBoxcenter .planBoxcenterlist .editortext{
	width:67px;
	height: 29px;
	background-color: #3e99f2;
	border-radius: 15px;
	font-size: 14px;
	color: #fff;
	text-align: center;
	line-height: 29px;
	cursor: pointer;
	margin-left: 15px;
}
.planBoxs .planBoxcenter .planBoxcenterlist .chakan{
	font-size: 14px;
	color: #3e99f2;
	text-align: center;
	cursor: pointer;
}
.planBoxs .planBoxbottom{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.planBoxs .planBoxbottom .backtext{
	width: 80px;
	height: 26px;
	background-color: #3e99f2;
	border-radius: 5px;
	text-align: center;
	line-height: 26px;
	color: #fff;
	font-size: 14px;
	cursor: pointer;
}
.h-calendarSelect .h-selectLine {
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.30rem;
  margin-right: 0.12rem;
  font-size: 0.22rem;
  color: #2381e8;
}
/* .selecBox .button:first-child{
	border-right-color: #2686e7;
} */
.textBox{
	margin-top: 20px;
	margin-left: 20px;
}
.textBox span{
	color: #bec3c4;
	font-size: 16px;
	margin-left: 30px;
}
.textBox span:first-child{
	margin: 0;
}
.paimingBox{
	margin-top: 50px;
	display: flex;
	flex-direction: column;
	margin-left: 10px;
}
.paimingBox .title{
	font-size: 14px;
	color: #c6ced1;
	margin-bottom: 10px;
}
.paimingBox .borderBox{
	width: 160px;
	height: 12px;
	border-radius: 6px;
	background: #def2ff;
	position: relative;
}
.paimingBox .borderBox .borders{
	position: absolute;
	width: 0%;
	height: 12px;
	border-radius: 6px;
	background: #5aabff;
}
.agentBox{
	width: 100%;
	padding: 0 20px;
	padding-top: 20px;
}
.agentBox::-webkit-scrollbar {
	width:0.1rem;
	background: rgba(0, 0, 0, 0.1);
	border-radius: 0.05rem;
	height: 1rem;
}
.agentBox::-webkit-scrollbar-thumb{
	background: rgb(0, 92, 253);
	border-radius: 0.05rem;
}
.agentBox .agent{
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 20px;
}
.agentBox .agent:first-child{
	margin-top:0
}
.agentBox .agent .agentTop{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.agentBox .agent .agentTop .circle{
	width: 12px;
	height: 12px;
	border: 3px solid #64a5f8;
	margin-right: 10px;
	border-radius: 50%;
}
.agentBox .agent .agentTop .titles{
	font-size: 16px;
	color: #a9a9a9;
}
.agentBox .agent .agentBottom{
	margin-top: 20px;
	display: flex;
}
.agentBox .agent .agentBottom .zhaobox{
	width: 90%;
	height: 16px;
	background: #e2f1ff;
	border-radius: 8px;
	position: relative;
}
.agentBox .agent .agentBottom .nums{
	width: 11%;
	font-size: 16px;
	color: #a9a9a9;
	text-align: right;
}
.agentBox .agent .agentBottom .zhaobox .zhao{
	position: absolute;
	top: 0;
	left:0;
	width: 16.5%;
	height: 16px;
	border-radius: 8px;
	background: #005cfd;
	transition: all 0.3s;
	max-width: 100%;
}
.agentBox .agent .agentBottom .zhaobox:hover .zhao .imgs{
	display: block;
}
.agentBox .agent .agentBottom .zhaobox .zhao .imgs{
	width: 126px;
	height: 57px;
	background: url(../../../assets/images/titp.png);
	position: absolute;
	top: -60px;
	right: -90px;
	color: #949b9e;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	display: none;
}
.agentBox .lines{
	width: 100%;
	height: 1px;
	background: #f6f6f6;
	margin-top: 80px;
}
.agentBox .lineBox{
	position: relative;
	width: 100%;
	display: flex;
}
.agentBox .lineBox .linelist{
	width: 16.5%;
	margin-top: 10px;
	text-align: left;
	font-size: 14px;
	color:#4d4d4d;
}
.agentBox .lineBox .test{
	position: absolute;
	top: -25px;
	left: 0;
	font-size: 14px;
	color:#4d4d4d;
}
</style>
<style>
.h-calenderSign span:last-child{
	margin-right: 0
}
.h-tableCell .el-input__inner {
	width: 1.3rem;
    color: #DCDFE6;
    border-radius: 0;
    height: 0.32rem;
    line-height: 0.28rem;
    border: 1px solid #DCDFE6;
    font-size: 0.16rem;
    padding-right: 0.3rem;
    padding-left: 0.15rem;
}
.h-tableCell .el-input__icon{
	line-height: 0;
}
.fenyes .h-pagiLabel{
	display: none;
}
.fenyes .el-pagination .el-pagination__sizes{
	display: none;
}
.h-formReason .h-formbLine .el-textarea .el-textarea__inner{
	height: 23px!important;
	min-height: none;
}
.custom-alert {
	width: 1050px !important;
	height: 450px !important;
}

/* 在全局样式文件中添加 */

/* 在全局样式文件中添加 */
/* 1. 控制最外层弹窗容器：强制宽度和居中 */
.big-image-alert {
    width: 1100px !important;      /* 必须加 !important 覆盖默认 max-width */
    max-width: none !important;    /* 清除最大宽度限制 */
    padding: 0;                    /* 清除外层 padding */
    margin: 0 auto;                /* 确保居中 */
}

/* 2. 控制图片容器，隐藏滚动条 */
.big-image-alert .el-message-box__message {
    padding: 0;
    margin: 0;
    height: auto;     /* 高度自适应 */
    overflow: hidden; /* 彻底隐藏滚动条 */
}

/* 3. 图片样式：强制撑满 */
.big-image-alert .el-message-box__message img {
    width: 1100px;    /* 固定宽度，或者使用 100% */
    height: 580px;    /* 固定高度 */
    display: block;
    object-fit: fill; /* 确保图片完全拉伸充满，不保持比例 */
}
</style>
